module.exports = __webpack_public_path__ + "img/person_placeholder.d5241385.jpg";